<template>
	<div class="phhmore">
		<el-backtop ></el-backtop>
		<!-- <div class="phhomre-hea">
			<div class="morehea-left">
				<img :src="$store.state.phLogoImage" />
			</div>
			<div class="morehea-right" @click="goOff()">
				<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmoredown.png" />
			</div>
		</div> -->
		<hpheader></hpheader>
		<div class="phhomre-seach">
			<div class="seach-con" @click="navtoseach()">
				<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmoreseach.png" />
				<div class="seachcon-title"></div>
			</div>
		</div>
		<div class="menu">
			<div class="menu-cont" >
				<div class="menu-item">
					<div class="menuitem-hea" @click="navtophhome">
						<div class="menuitehea-left">{{moreho}}</div>
					</div>
				</div>

				<div class="menu-item">
					<div class="menupro-hea">
						<div class="menuprohea-heade">
							<div class="menuitehea-left" @click="navtoproduct">{{product_name}}</div>
							<div class="menuitehea-right" @click="productfoot()">
								<img v-if="productfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmorejian.png" />
								<img v-if="!productfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmoresum.png" />
							</div>
						</div>
						<div v-if="productfoo">
							<div class="menuitem-foo">
								<div class="meotoppas">
									<ul>
										<li v-for="(item,index) in categorylist" @click="getProductCateList(item.id)" :class="morepro==item.id?'acmorecl':''">
											{{item.name}}
										</li>
									</ul>
									<!-- <div class="menuit-foosada" v-for="(item,index) in categorylist" @click="getProductCateList(item.id)" :class="morepro==item.id?'acmorecl':''">
										{{item.name}}
									</div> -->
									<!-- <div style="width:100%;height:10px;background:pink"></div> -->
								</div>
								<div class="menuprohea-footer" >
									<div class="menuproheafoo-item" v-for="(item, index) in list_img" :key="index"  @click="toProduct(item.id)">
										<img :src="item.menu_image" />
										<div class="menuproheafoo-title">{{item.name}}</div>
									</div>
									
								</div>
							</div>
							
							
						</div>
					</div>
				</div>
<!--				<div class="menu-item">-->
<!--					<div class="menuitem-hea">-->
<!--						<div class="menuitehea-left" @click="navtovideos()">{{videos.title}}</div>-->
<!--						<div class="menuitehea-right" @click="videosfoot()">-->
<!--							<img v-if="videosfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmorejian.png" />-->
<!--							<img v-if="!videosfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmoresum.png" />-->
<!--						</div>-->
<!--					</div>-->
<!--					<div class="menuitem-foo" v-if="videosfoo">-->
<!--						<div class="menuit-foo" v-for="(item,index) in videos.list" @click="navtovideos(index)">-->
<!--							{{item.name}}-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->

				<div class="menu-item">
					<div class="menuitem-hea">
						<div class="menuitehea-left" @click="navtoeducation(1)">{{education.title}}</div>
						<div class="menuitehea-right" @click="educationfoot()">
							<img v-if="educationfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmorejian.png" />
							<img v-if="!educationfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmoresum.png" />
						</div>
					</div>
					<div class="menuitem-foo"  v-if="educationfoo">
						<div class="menuit-foo" v-for="(item,index) in education.list" @click="navtoeducation(item.id)">
							{{item.name}}
						</div>
					</div>
				</div>

				<div class="menu-item">
					<div class="menuitem-hea">
						<div class="menuitehea-left" @click="navtoquery()">{{user_serve.title}}</div>
						<div class="menuitehea-right" @click="queryfoot()">
							<img v-if="queryfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmorejian.png" />
							<img v-if="!queryfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmoresum.png" />
						</div>
					</div>
					<div class="menuitem-foo"  v-if="queryfoo">
						<div class="menuit-foo" v-for="(item,index) in user_serve.list" @click="navtoquery(item.id)">
							{{item.name}}
						</div>
					</div>
				</div>
        <div class="menu-item">
          <div class="menuitem-hea">
            <div class="menuitehea-left" @click="toLearn()">{{learnSite.title}}</div>
<!--            <div class="menuitehea-right" @click="toLearn()">-->
<!--              <img v-if="queryfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmorejian.png" />-->
<!--              <img v-if="!queryfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmoresum.png" />-->
<!--            </div>-->
          </div>
<!--          <div class="menuitem-foo"  v-if="queryfoo">-->
<!--            <div class="menuit-foo" v-for="(item,index) in user_serve.list" @click="navtoquery(item.id)">-->
<!--              {{item.name}}-->
<!--            </div>-->
<!--          </div>-->
        </div>
				<div class="menu-item">
					<div class="menuitem-hea">
						<div class="menuitehea-left" @click="navtoaboutlist(0)">{{about_us.title}}</div>
						<div class="menuitehea-right" @click="aboutfoot()">
							<img v-if="aboutfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmorejian.png" />
							<img v-if="!aboutfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmoresum.png" />
						</div>
					</div>
					<div class="menuitem-foo" v-if="aboutfoo">
						<div class="menuit-fooccd" @click="navtoaboutlist(index)"  v-for="(item,index) in about_us.list" >
							{{item.name}}
						</div>
					</div>
				</div>
<!--				<div class="menu-item">-->
<!--					<div class="menuitem-hea">-->
<!--						<div class="menuitehea-left" @click="navtoelites(1)">{{recruit.title}}</div>-->
<!--						<div class="menuitehea-right" @click="elitesfoot()">-->
<!--							<img v-if="elitesfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmorejian.png" />-->
<!--							<img v-if="!elitesfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmoresum.png" />-->
<!--						</div>-->
<!--					</div>-->
<!--					<div class="menuitem-foo"  v-if="elitesfoo">-->
<!--						<div class="menuit-foo" v-for="(item,index) in recruit.list" @click="navtoelites(item.id)">-->
<!--							{{item.name}}-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
				<div class="menu-item">
					<div class="menuitem-hea">
						<div class="menuitehea-left" @click="navtonews()">{{news.title}}</div>
						<!--						<div class="menuitehea-right" @click="newsfoot()">-->
						<!--							<img v-if="newsfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmorejian.png" />-->
						<!--							<img v-if="!newsfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmoresum.png" />-->
						<!--						</div>-->
					</div>
					<div class="menuitem-foo" v-if="newsfoo" >
						<div class="menuit-foo" v-for="(item,index) in news.list" @click="navtonews(item.id)">
							{{item.name}}
						</div>
					</div>
				</div>
				<div class="menu-item">
					<div class="menuitem-hea">
						<div class="menuitehea-left" @click="navtocontactus()">{{contact.title}}</div>
						<div class="menuitehea-right" @click="contactfoot()">
							<img v-if="contactfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmorejian.png" />
							<img v-if="!contactfoo" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phmoreimg/phmoresum.png" />
						</div>
					</div>
					<div class="menuitem-foo" v-if="contactfoo" >
						<div class="menuit-foo" v-for="(item,index) in contact.list" @click="navtocontactus(item.id)">
							{{item.name}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="phhmore-foo">
<!--			<div class="website chinesss" @click="navtocompany">-->
<!--				<span>{{pc_name}}</span>-->
<!--			</div>-->
			<div class="website" @click="navtolangu">
				<span>{{lang}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {session} from "../../storage/storage";
	import hpheader from '../../common/hpheader.vue'
	export default{
		data(){
			return{
				title:'',
				morepro:0,
				product_name:"",
				moreho:"首页",
				aboutfoo:false,
				productfoo:false,
				videosfoo:false,
				queryfoo:false,
				educationfoo:false,
				elitesfoo:false,
				newsfoo:false,
				contactfoo:false,
				tips:"",
				about_us:[],
				videos:[],
				contact_us:[],
				user_serve:[],
				recruit:[],
				contact:[],
        learnSite:[],
				categorylistconts:[],
				list_img:[],
				categorylist:[],
				pc_name:"",
				lang:"",
				news:[],
				bigShot:{
					data:{}
				}
			}
		},
		components:{hpheader},
		created() {
			window.scrollTo(0,0);
			if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
				this.$router.push({path:'./'})
			}
			this.ress()
			this.pageParam()
			this.getProductList();

		},
		mounted() {
			this.ress()
		},
		methods:{
			contactfoot(){
				if(this.contactfoo){
					this.contactfoo=false
				}else{
					this.contactfoo=true
				}
				
			},
			elitesfoot(){
				if(this.elitesfoo){
					this.elitesfoo=false
				}else{
					this.elitesfoo=true
				}
				
			},
			educationfoot(){
				if(this.educationfoo){
					this.educationfoo = false
				}else {
					this.educationfoo = true
				}
			},
			queryfoot(){
				if(this.queryfoo){
					this.queryfoo=false
				}else{
					this.queryfoo=true
				}
				
			},
			videosfoot(){
				if(this.videosfoo){
					this.videosfoo=false
				}else{
					this.videosfoo=true
				}
			},
			productfoot(){
				if(this.productfoo){
					this.productfoo=false
				}else{
					this.productfoo=true
				}
				
			},
			
			aboutfoot(){
				if(this.aboutfoo){
					this.aboutfoo=false
				}else{
					this.aboutfoo=true
				}
				
			},
			navtophhome(){
				this.$router.push({path: '/phhome'});
			},
			navtoaboutlist(e){
				console.log(e)
				if(e==0){
					this.$router.push({path: '/phabout'})
				}else if(e==1){
					this.$router.push({path: '/phenviron'})
				}else if(e==2){
					this.$router.push({path: '/phhonor'})
				}else if(e==3){
					this.$router.push({path: '/phnews'})
				}
			},
			goOff(){
			    this.$router.go(-1);
			},
			getProductList(){
				let data={
					lang:session.get('lang'),
					channel_id: session.get('channel_id'),
				}
				this.$api.get_channel_category_list(data).then((res) => {
				this.categorylist=res.data
				this.categorylistconts=[]
				for(let l =0;l<this.pronavnums;l++){
					this.categorylistconts.push(this.categorylist[l])
				}
				this.getProductCateList(res.data[0].id)
		
				});
			},
			getProductCateList(id){ //根据分类id获取产品
				this.morepro=id
				let data={
				lang:session.get("lang") == null ? 'en' : session.get("lang"),
				channel_id: session.get("channel_id") == null ? 1 : session.get("channel_id"),
				page:1,
				pageSize:10,
				category_id:id,
				mold:"h5",
				}
				this.$api.get_channel_category_id_list(data).then((res) => {
				this.list_img=res.data
				});
			},
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.product_name = "产品中心",
					this.tips = "请输入你要搜索的产品名称",
					this.pc_name = '请选择品牌',
					this.lang = '选择语言'
					this.product_centet = "产品中心",
					this.moreho="首页"
					this.about_us = {
						'title':"关于我们",
						'list' :[
							{'name':"关于啄木鸟",'id':1},
							{'name':"公司环境",'id':2},
							{'name':"公司荣誉",'id':3},
							{'name':"新闻中心",'id':4}
						]
					},
					this.videos = {
						'title':"视频中心",
						'list' :[
							{'name':"产品介绍",'id':1},
							{'name':"案例分析",'id':2},
							{'name':"网络课程",'id':3},
						]
					},
					this.user_serve = {
						'title':"用户服务",
						'list' :[
							{'name':"防伪鉴别",'id':1},
							{'name':"资料下载",'id':2},
							{'name':"维护保养",'id':3},
							{'name':"常见问题",'id':4},
						]
					},
              this.learnSite = {
                'title':"学习中心",
                'list' :[
                  {'name':"产品介绍",'id':1},
                  {'name':"案例分析",'id':2},
                  {'name':"网络课程",'id':3},
                ]
              }
					this.recruit = {
						'title':"诚聘精英",
						'list' :[
							{'name':"全部",'id':1},
							{'name':"社会招聘",'id':2},
							{'name':"校园招聘",'id':3},
						]
					},
					this.contact = {
						'title':"联系我们",
						'list' :[
							{'name':"地图",'id':1},
							{'name':"留言",'id':2},
						]
					}
				}else{
					this.product_name = "PRODUCTS",
					this.tips = "Please enter the product name you want to search",
					this.product_centet = "Product Center",
						this.pc_name = 'Brand',
						this.lang = 'Language'
						this.moreho="HOME"
					this.about_us = {
						'title':"ABOUT US",
						'list' :[
						{'name':"About Woodpecker",'id':1},
						{'name':"Company Corner",'id':2},
						{'name':"Honors",'id':3},
						// {'name':"News",'id':4}
						]
					},
					this.videos = {
						'title': "VIDEO",
						'list': [
						{'name': "Product Introduction", 'id': 1},
						{'name': "Case Sharing", 'id': 2},
						{'name': "Webinar", 'id': 3},
						],
					},
					this.education = {
						'title':"ACADEMY",
						'list' :[
							{'name':"Courses",'id':1},
							{'name':"Videos",'id':2},
						]
					},
					this.user_serve = {
						'title':"USERS SERVICE",
						'list' :[
						{'name':"Anti-Fake Inquiry",'id':1},
						// {'name':"Maintenance",'id':2},
						{'name':"Specific Comparison",'id':5},
						{'name':"Download",'id':3},
						// {'name':"FAQ",'id':4},
						]
					},
					this.news = {
						'title':"NEWS",
						'list' :[]
					},
              this.learnSite = {
                'title':"LEARNING CENTER",
                'list' :[
                ]
              }
					// this.recruit = {
					// 	'title':"JOIN US",
					// 	'list' :[
					// 	{'name':"All",'id':1},
					// 	{'name':"General Recruitment",'id':2},
					// 	{'name':"Campus Recruitment",'id':3},
					// 	]
					// },
					this.contact = {
						'title':"CONTACT US",
						'list' :[
							{'name':"Map",'id':1},
							{'name':"Online Message",'id':2},
							{'name':"Join Us",'id':3},

						]
					}
				}
		
		
			},
			navtoseach(){
				this.$router.push({path: '/phseachs'})
			},
			navtoquery(e){
				// this.$router.push({path: '/phquerys',query:{e}})
        switch (e){
          case 3:
            this.$router.push({path: '/ph/download'});
            break;
          case 5:
            this.$router.push({path: '/ph/compare/category'});
            break;
          default:
            this.$router.push({path: '/phquerys'});
            break;
        }
			},
			navtoeducation(e){
				switch (e) {
					case 1:
						this.$router.push({path: '/phcourses'})
						break;
					case 2:
						this.$router.push({path: '/ph-academy-videos'})
						break;
				}
			},
      toLearn(){
        window.open('http://121.41.73.197?lang=en')
      },
			navtoelites(e){
				this.$router.push({path: '/phelites',query:{e}})
			},
			navtocontactus(e){
				if(e == 3){
					this.$router.push({path: '/phelites'})
				}else {
					this.$router.push({path: '/phcontactus',query:{e}})
				}
			},
			navtovideos(e){
				this.$router.push({path: '/phvideos',query:{e}})
			},
			navtocompany(){
				this.$router.push({path: '/phcompany'})
			},
			navtolangu(){
				this.$router.push({path: '/phlangu'})
			},
			navtoabout(){
				this.$router.push({path: '/phabout'})
			},
			navtoenviron(){
				this.$router.push({path: '/phenviron'})
			},
			navtohonor(){
				this.$router.push({path: '/phhonor'})
			},
			navtonews(){
				this.$router.push({path: '/ph-news'})
			},
			navtoproduct(){
				this.$router.push({path: '/phproduct'})
			},
			toProduct(e){
				this.$router.push({ path: "/phdetails",query: {e,type:'phone'}});
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
			
			
		}
	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}
	.phhmore{
		width: 7.5rem;
		position: relative;
		padding-top: 0.88rem;
		/* width: 7.5rem;
		height: 22.65rem;
		background-color: #666666; */
		background: #F0F2F5;
		/* min-height: 100vh; */
	}
	.phhomre-hea{
		width: 7.5rem;
		height: 0.88rem;
		background: #FFFFFF;
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
	}
	.morehea-left{
		width: 0.97rem;
		height: 0.5rem;
		margin-left: 0.3rem;
		display: flex;
	}
	.morehea-left img{
		width: 100%;
		height: 100%;
	}
	.morehea-right{
		width: 0.38rem;
		height: 0.38rem;
		margin-right: 0.3rem;
		display: flex;
	}
	.morehea-right img{
		width: 100%;
		height: 100%;
	}
	.phhomre-seach{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.seach-con{
		width: 5.8rem;
		height: 0.84rem;
		background: #F7F7F7;
		border-radius: 0.42rem;
		display: flex;
		align-items: center;
		margin-top: 0.24rem;
	}
	.seach-con img{
		width: 0.36rem;
		height: 0.36rem;
		margin-left: 0.24rem;
	}
	.seachcon-title{
		font-size: 0.28rem;
		font-weight: 400;
		color: #999999;
		letter-spacing: 0.01rem;
		margin-left: 0.16rem;
	}
	.menu{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.menu-cont{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-top: 0.24rem;
	}
	.menu-item{
		
	}
	.menuitem-hea{
		display: flex;
		justify-content: space-between;
		align-items: center;
		
		width: 6.9rem;
		height: 1.2rem;
		box-shadow: 0rem 0.01rem 0rem 0rem #CCCCCC;
	}
	.menuitehea-left{
		font-size: 0.28rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
	}
	.menuitehea-right{
		width: 0.22rem;
		height: 0.22rem;
		display: flex;
	}
	.menuitehea-right img{
		width: 100%;
		height: 100%;
	}
	.phhmore-foo{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding-bottom: 0.5rem;
	}
	.website{
		margin-top: 2.29rem;
		font-size: 0.28rem;
		font-weight: 400;
		color: #999999;
		letter-spacing: 0.01rem;
	}
	.website span {
		border-bottom: 0.01rem solid #999;
	}
	.chinesss{
		margin-top: 0.32rem;
		font-size: 0.28rem;
		font-weight: 400;
		color: #999999;
		letter-spacing: 0.01rem;
	}
	.chinesss span{
		border-bottom: 0.01rem solid #999;
	}
	.menuitem-foo{
		box-shadow: 0rem 0.01rem 0rem 0rem #CCCCCC;
		padding-bottom: 0.24rem;
	}
	.menuit-foo{
		margin-top: 0.24rem;
		font-size: 0.24rem;
		font-weight: 400;
		color: #666666;
		letter-spacing: 0.01rem;
	}
	.menupro-hea{
		width: 6.9rem;
		box-shadow: 0rem 0.01rem 0rem 0rem #CCCCCC;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.menuprohea-heade{
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 6.9rem;
		height: 1.2rem;
	}
	.menuprohea-footer{
		display: flex;
		align-items: center;
		width: 6.9rem;
		overflow-x: auto;
	}

	.menuproheafoo-item:last-child{
		margin-right: 0rem;
	}
	.menuproheafoo-item{
		display: flex;
		flex-direction: column;
		margin-right: 0.24rem;
	}
	.menuproheafoo-item img{
		width: 2rem;
		height: 2rem;
	}
	.menuproheafoo-title{
		font-size: 0.24rem;
		font-weight: 400;
		color: #666666;
		margin-top: 0.24rem;
		letter-spacing: 0.01rem;
		height: 1rem;
	}
	.meotoppas{
		display: flex;
		align-items: center;
		width: 6.9rem;
		overflow-x: auto;
		/* overflow: initial; */
		/* background: red; */
	}
	.meotoppas::-webkit-scrollbar {
		width: 0;    
	}
	.menuprohea-footer::-webkit-scrollbar {
		width: 0;    
	}
	.meotoppas ::after{
		contain:"";
		background: yellow;
		width: 100px;
		height: 100px;
	}

	.menuit-foosada{
		min-width: 2.1rem;
		width: 100%;
		overflow: auto;
		font-size: 0.28rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-bottom: 0.3rem;
	}
	.acmorecl{
		color: #D03E3D;
	}
	.menuit-fooccd{
		margin-top: 0.24rem;
		font-size: 0.24rem;
		font-weight: 400;
		color: #666666;
		letter-spacing: 0.01rem;
	}
	.meotoppas ul{
		display: flex;
		padding: 0;
		margin:  0.3rem 0;
	}
	.meotoppas ul li{
		font-size: 0.28rem;
		list-style: none;
		flex-shrink: 0;
		margin-right: 0.4rem;
	}
	.meotoppas ul li:first-child{
		
	}
</style>
